import { render } from "./KleinHuiskamerconcert.vue?vue&type=template&id=abdef04c&scoped=true"
import script from "./KleinHuiskamerconcert.vue?vue&type=script&lang=js"
export * from "./KleinHuiskamerconcert.vue?vue&type=script&lang=js"

import "./KleinHuiskamerconcert.vue?vue&type=style&index=0&id=abdef04c&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abdef04c"]])

export default __exports__